<template>
  <div class="batchAdjustment padd30">
    <div>
      <div class="box20"></div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="货品名称" width="300">
          <template slot-scope="scope">
            <el-input clearable v-model="scope.row.name" placeholder="请输入"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="商品图">
          <template slot="header">
            <span class="relative cursor table_hint_wrap">
              <i class="el-icon-warning-outline gray9"></i>
              <span class="table_hint w165">只对商品第一张图进行管理</span>
            </span>
            <span class="pad5_l">商品图</span>
          </template>
          <template slot-scope="scope">
            <span v-if="scope.row.img">
              <span class="c_blue pad10_lr cursor" @click="onPreview(scope.row.img)">预览</span>
              <span class="c_blue pad10_lr cursor" @click="changeImg(scope.row.img, scope.$index)">
                <el-upload
                  class="upload-demo"
                  action="https://upload-z2.qiniup.com/"
                  :show-file-list="false"
                  :on-success="handleSuccess"
                  :before-upload="beforeUpload"
                  :on-remove="handleRemove"
                  :data="postData"
                >
                  <span class="c_blue pad10_lr cursor">更换</span>
                  <!--@click="changeImg(scope.row.img,scope.$index)"-->
                </el-upload>
              </span>
            </span>
            <span v-else @click="changeImg(scope.row.img, scope.$index)">
              <el-upload
                class="upload-demo"
                action="https://upload-z2.qiniup.com/"
                :show-file-list="false"
                :on-success="handleSuccess"
                :before-upload="beforeUpload"
                :on-remove="handleRemove"
                :data="postData"
              >
                <span class="c_blue pad10_lr cursor">上传图片</span>
                <!--@click="changeImg(scope.row.img,scope.$index)"-->
              </el-upload>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="分类">
          <template slot="header">
            <span class="relative cursor table_hint_wrap">
              <i class="el-icon-warning-outline gray9"></i>
              <span class="table_hint w195">请在商品管理-分类管理进行设置</span>
            </span>
            <span class="pad5_l">分类</span>
          </template>
          <template slot-scope="scope">
            <el-select v-model="scope.row.sort" placeholder="请选择">
              <el-option v-for="item in sortList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="价格">
          <!--el-icon-edit-outline-->
          <template slot="header">
            <span>价格</span>
            <span class="relative cursor table_hint_wrap">
              <i class="el-icon-edit-outline pad5_l gray9" @click="drawerDialog = true"></i>
              <span class="table_hint table_hint_price w116">点击批量调整价格</span>
            </span>
          </template>
          <template slot-scope="scope">
            <!--改变输入框的边框的样式-->
            <!--class="changeInput"-->
            <el-input clearable v-model="scope.row.price" placeholder="请输入"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="计量单位">
          <template slot-scope="scope">
            <el-select v-model="scope.row.unit" filterable placeholder="请选择">
              <el-option v-for="item in sortList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="库存">
          <template slot="header">
            <span>库存</span>
            <span class="relative cursor table_hint_wrap">
              <i class="el-icon-edit-outline pad5_l gray9" @click="drawerDialog = true"></i>
              <span class="table_hint table_hint_price w116">点击批量调整库存</span>
            </span>
          </template>
          <template slot-scope="scope">
            <el-input clearable v-model="scope.row.stock" placeholder="请输入"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="销售单位">
          <template slot-scope="scope">
            <el-select v-model="scope.row.marketingUnit" filterable placeholder="请选择">
              <el-option v-for="item in sortList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="换算比例">
          <template slot="header">
            <span class="relative cursor table_hint_wrap">
              <i class="el-icon-warning-outline gray9"></i>
              <span class="table_hint w368">销售单位与计量单位的换算比例，如：70公斤/头，换算比例为70</span>
            </span>
            <span class="pad5_l">换算比例</span>
          </template>
          <template slot-scope="scope">
            <el-input clearable v-model="scope.row.conversion" placeholder="请输入"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="微信支付">
          <template slot="header">
            <span class="relative cursor table_hint_wrap">
              <i class="el-icon-warning-outline gray9"></i>
              <span class="table_hint w320">启用后该商品支持微信支付，您将承担千分之六的手续费</span>
            </span>
            <span class="pad5_l">微信支付</span>
          </template>
          <template slot-scope="scope">
            <el-switch v-model="scope.row.wxPay" active-color="#13ce66" inactive-color="#cccccc"> </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="配送范围">
          <template slot-scope="scope">
            <el-select v-model="scope.row.delivery" filterable placeholder="请选择">
              <el-option v-for="item in sortList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="运费">
          <template slot-scope="scope">
            <el-select v-model="scope.row.freight" filterable placeholder="请选择">
              <el-option v-for="item in sortList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="[imgViewer]" />
    <el-drawer direction="rtl" :title="drawerTitle" :visible.sync="drawerDialog" custom-class="demo-drawer" ref="drawer">
      <div class="demo-drawer__content">
        <el-form :model="drawerForm">
          <el-form-item label="调整方案：" label-width="120px">
            <el-radio-group v-model="drawerForm.method">
              <el-radio :label="1">按数值</el-radio>
              <el-radio :label="2">按比例</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="调整目标：" label-width="120px">
            <el-radio-group v-model="drawerForm.amend">
              <el-radio :label="1">增加</el-radio>
              <el-radio :label="2">降低</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="" label-width="120px">
            <el-input v-model="drawerForm.num"></el-input>
          </el-form-item>
        </el-form>
        <div class="demo-drawer_hint">
          <span v-if="drawerForm.method === 1">当前所有商品在原价格基础上 增加 100</span>
          <span v-else>当前所有商品在原价格基础上 增加 10%</span>
        </div>
        <div class="demo-drawer__footer">
          <el-button @click="drawerDialog = false">取 消</el-button>
          <el-button type="primary" @click="drawerDialog = false">确 定</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<!--scoped-->
<style lang="scss" scoped>
@import "./index.scss";
</style>

<script>
import { mapState } from "vuex";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  components: { ElImageViewer },
  data() {
    return {
      drawerTitle: "批量调价", // 批量调整库存
      drawerDialog: false,
      drawerForm: {
        method: 1,
        amend: 2,
        num: "",
      },
      curIndex: 0, // 当前点击的index
      origin: process.env,
      imageUrl: "",
      postData: {
        token: "",
      },
      uploadVisible: false, // 是否显示上传图片弹窗
      imgViewer: "", // 预览大图的地址
      showViewer: false, // 是否显示预览大图
      tableData: [
        {
          name: "货品名称",
          img: "https://filesouthcdn.nxin.com/nxsc_161724489575205408477582834749.JPEG",
          sort: "",
          price: "10",
          unit: "",
          stock: "1000",
          marketingUnit: "",
          conversion: "100",
          wxPay: false,
          delivery: "",
          freight: "",
        },
        {
          name: "货品名称",
          img: "",
          sort: "",
          price: "10",
          unit: "",
          stock: "1000",
          marketingUnit: "",
          conversion: "100",
          wxPay: false,
          delivery: "",
          freight: "",
        },
        {
          name: "货品名称",
          img: "",
          sort: "",
          price: "10",
          unit: "",
          stock: "1000",
          marketingUnit: "",
          conversion: "100",
          wxPay: false,
          delivery: "",
          freight: "",
        },
        {
          name: "货品名称",
          img: "",
          sort: "",
          price: "10",
          unit: "",
          stock: "1000",
          marketingUnit: "",
          conversion: "100",
          wxPay: false,
          delivery: "",
          freight: "",
        },
        {
          name: "货品名称",
          img: "",
          sort: "",
          price: "10",
          unit: "",
          stock: "1000",
          marketingUnit: "",
          conversion: "100",
          wxPay: false,
          delivery: "",
          freight: "",
        },
      ],
      sortList: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
    };
  },
  computed: mapState({
    showTitle: (state) => state.app.showTitle,
  }),
  created() {
    this.$store.commit("app/setShowTitle", false);
    this.goodsToken();
  },

  mounted() {},
  methods: {
    // 获取上传文件时候的token
    goodsToken() {
      this.$store.dispatch("app/getUploadToken").then((data) => {
        this.postData.token = data;
      });
    },
    // 上传成功后在图片框显示图片
    handleSuccess(res) {
      this.imageUrl = `${this.origin.VUE_APP_IMGURL}${res.key}`;
      this.tableData[this.curIndex].img = this.imageUrl;
      this.$set(this.tableData, this.curIndex, this.tableData[this.curIndex]);
    },
    // 删除图片
    handleRemove() {
      this.imageUrl = "";
    },
    // 上传图片之前
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message({
          message: "上传图片大小不能超过 2MB",
          type: "warning",
        });
      } else if (!isJPG && !isPNG) {
        this.$message({
          message: "上传图片必须是JPG/PNG 格式",
          type: "warning",
        });
      }
      return (isJPG || isPNG) && isLt2M;
    },
    // 点击更换图片
    changeImg(img, index) {
      this.curIndex = index;
      this.imageUrl = img;
    },
    // 点击预览大图
    onPreview(img) {
      this.imgViewer = img;
      this.showViewer = true;
    },
    // 关闭预览大图
    closeViewer() {
      this.showViewer = false;
    },
  },
};
</script>
